import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.string,
  label: PropTypes.string,
};

export default function RHFTextField({ name, helperText, label, labelVariant='subtitle2', ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Stack spacing={1} sx={{ width: 1 }}>
          {label && (
            <Typography variant={labelVariant}>
              {label}
            </Typography>
          )}
          <TextField {...field} fullWidth error={!!error} helperText={error? error.message : helperText} {...other} />
        </Stack>
      )}
    />
  );
}
